import { Component, input } from '@angular/core';

@Component({
  selector: 'app-badge',
  standalone: true,
  template: `
    <span class="badge" [class.is-soft]="variant() === 'soft'" [style.--badge-color]="color()">
      <ng-content></ng-content>
    </span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        line-height: 1;
      }

      .badge {
        --badge-color: #334155;
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 22px;
        min-height: 22px;
        padding: 0 8px;
        border-radius: 999px;
        border: 1px solid color-mix(in srgb, var(--badge-color) 38%, var(--border));
        background: var(--badge-color);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.03em;
        line-height: 1;
        text-transform: uppercase;
        white-space: nowrap;
      }

      .badge.is-soft {
        background: color-mix(in srgb, var(--badge-color) 16%, transparent);
        color: color-mix(in srgb, var(--badge-color) 72%, var(--text));
      }
    `,
  ],
})
export class BadgeComponent {
  readonly color = input<string>('#334155');
  readonly variant = input<'solid' | 'soft'>('soft');
}
